import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchDataForItemPage } from '@/redux/modules/itemPage';
import { getIdFromPath } from '@/utils/urls';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch } = store;
    const itemId = getIdFromPath(params.itemId);

    if (!itemId) {
        return Promise.resolve();
    }

    return dispatch(fetchDataForItemPage(itemId));
};
